import * as SuperTokens from 'supertokens-web-js';
import type { RecipePreAPIHookContext } from 'supertokens-web-js/lib/build/recipe/recipeModule/types';
import Passwordless from 'supertokens-web-js/recipe/passwordless';
import Session, { type RecipeInterface, type SessionClaimValidator } from 'supertokens-web-js/recipe/session';

import { environment } from 'src/environments/environment';

import { PASSWORDLESS_CLAIM } from '../models/passwordless.claim';

import getCookieHandler from './cookie-handler';

function addHeaders(context: RecipePreAPIHookContext<unknown>): RecipePreAPIHookContext<unknown> {
  const headers: Record<string, string> = {
    ...(context.requestInit.headers as Record<string, string>),
    // TODO: Implement this correctly after values are stored in correct place
    'X-USER-TIMEZONE': Intl.DateTimeFormat().resolvedOptions().timeZone,
    'X-TENANT-ID': environment.organizationSlug,
    'X-ORIGIN': environment.redirectUri,
    'X-REDIRECT-URI': environment.redirectUri,
  };

  if (context.action === 'REFRESH_SESSION') {
    for (const cookie of document.cookie.split('; ')) {
      const [key, value] = cookie.split('=');
      if (decodeURIComponent(key) === 'st-refresh-token') {
        headers['Authorization'] = `Bearer ${decodeURIComponent(value)}`;
        break;
      }
    }
  }

  context.requestInit.headers = headers;
  return context;
}

export function initSuperTokens(): void {
  SuperTokens.init({
    appInfo: {
      appName: 'Forthbridge patient app',
      apiDomain: environment.ollaApiUrl,
      apiBasePath: '/api/supertokens',
    },
    cookieHandler: getCookieHandler,
    recipeList: [
      Passwordless.init({
        preAPIHook: async (context) => addHeaders(context),
      }),
      Session.init({
        override: {
          functions(oI: RecipeInterface) {
            return {
              ...oI,
              getGlobalClaimValidators: ({ claimValidatorsAddedByOtherRecipes }): SessionClaimValidator[] => [
                ...claimValidatorsAddedByOtherRecipes,
                PASSWORDLESS_CLAIM.validators.isTrue(),
              ],
            };
          },
        },
        tokenTransferMethod: 'header',
        sessionTokenFrontendDomain: environment.sessionTokenFrontendDomain,
        preAPIHook: async (context) => addHeaders(context),
        postAPIHook: async (context) => {
          if (context.action === 'REFRESH_SESSION') {
            window.postMessage({ type: 'session-refresh' }, window.location.origin);
          }
        },
      }),
    ],
  });
}
